
import { Link } from 'react-router-dom';

interface ContentBlock {
  type: 'paragraph' | 'heading';
  text: string;
}

interface BlogDetailContentProps {
  data: {
    content: ContentBlock[];
  };
}

const BlogDetailContent = ({ data }: BlogDetailContentProps) => {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Content */}
        <article className="prose prose-lg max-w-none">
          {data.content.map((block, index) => {
            if (block.type === 'heading') {
              return (
                <h2
                  key={index}
                  className="font-poppins font-bold text-2xl text-gray-900 mt-10 mb-4"
                >
                  {block.text}
                </h2>
              );
            }
            return (
              <p
                key={index}
                className="font-inter text-base text-gray-700 leading-relaxed mb-6"
              >
                {block.text}
              </p>
            );
          })}
        </article>

        {/* CTA Section */}
        <div className="mt-16 p-8 bg-gradient-to-br from-[#007dff]/5 to-[#007dff]/10 rounded-2xl border border-[#007dff]/20">
          <div className="text-center">
            <h3 className="font-poppins font-bold text-2xl text-gray-900 mb-4">
              Dijital Büyüme Yolculuğunuza Başlayın
            </h3>
            <p className="font-inter text-base text-gray-600 mb-6 max-w-2xl mx-auto">
              Sigorta acentenizi dijital dünyada büyütmek için profesyonel destek mi arıyorsunuz? Size özel çözümlerimizi keşfedin.
            </p>
            <Link
              to="/iletisim"
              className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-[#007dff] to-[#0066dd] text-white font-poppins font-semibold rounded-xl hover:shadow-xl hover:shadow-[#007dff]/30 hover:scale-105 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              Ücretsiz Danışmanlık Alın
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>

        {/* Back to Blog */}
        <div className="mt-12 text-center">
          <Link
            to="/akademi"
            className="inline-flex items-center gap-2 font-poppins text-sm font-semibold text-[#007dff] hover:gap-3 transition-all cursor-pointer"
          >
            <i className="ri-arrow-left-line"></i>
            Tüm Yazılara Dön
          </Link>
        </div>
      </div>
    </section>
  );
};

export default BlogDetailContent;
